import { AuthLink, AuthShell } from './AuthShell';
import { PasswordForm } from './PasswordForm';

interface ChangePasswordPageProps {
  onChanged: () => void;
  onCancel: () => void;
}

/** First sign-in (or after a reset): the temporary password must be replaced before the console. */
export function ChangePasswordPage({ onChanged, onCancel }: ChangePasswordPageProps) {
  return (
    <AuthShell
      title="Đặt mật khẩu của bạn"
      description="Bạn đang dùng mật khẩu tạm do người tạo tài khoản đặt. Chọn mật khẩu riêng để tiếp tục."
    >
      <PasswordForm submitLabel="Lưu và tiếp tục" requireCurrent={false} onChanged={onChanged} />
      <AuthLink onClick={onCancel}>Đăng xuất</AuthLink>
    </AuthShell>
  );
}
